import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './redux/store'
import { Provider } from 'react-redux'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en.json'
import CallbackPage from './components/Auth/CallbackPage';
import SilentRenewPage from './components/Auth/SilentRenewPage';
import { NoAuthServer } from "./components/ErrorPages/NoAuthServer";
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './utils/ApplicationInsights';
import "bootstrap/dist/js/bootstrap.min.js";
import { TestPage } from './components/Test/TestPage';

TimeAgo.addDefaultLocale(en)

// After
const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  // <AppInsightsContext.Provider value={reactPlugin}></AppInsightsContext.Provider>
  <Provider store={store}>
    <BrowserRouter basename={process.env.PUBLIC_URL} future={{
      v7_relativeSplatPath: true,
    }}>
      <Routes>
        {/* For OAuth */}
        <Route path="/signin-callback" element={<CallbackPage />} />
        <Route path="/silent-renew" element={<SilentRenewPage />} />
        <Route path="/error/noauth" element={<NoAuthServer />} />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter >
  </Provider >

);

// const root = document.getElementById("root");
// render(
//   <React.StrictMode>
//     <AppInsightsContext.Provider value={reactPlugin}>
//       <Provider store={store}>
//         <BrowserRouter basename={process.env.PUBLIC_URL}>
//           <Routes>
//             {/* For OAuth */}
//             <Route path="/signin-callback" element={<CallbackPage />} />
//             <Route path="/silent-renew" element={<SilentRenewPage />} />
//             <Route path="/error/noauth" element={<NoAuthServer />} />
//             <Route path="*" element={<App />} />
//           </Routes>
//         </BrowserRouter >
//       </Provider >
//     </AppInsightsContext.Provider>
//   </React.StrictMode>,
//   root
// );

//<BrowserRouter  basename='/NewUx'>
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
